import React from "react"
import Button from "../../../../components/button";
import { windowObject } from "../../../../utils/browser-helpers";
import * as s from './css/premium-come-funziona.module.css'

const PremiumComeFunziona = ({ project }) => {

    return (
        <div className={`container-grid ${s.container}`}>
            <div className="col-span-4 desktop:col-span-8 desktop:col-start-3">
                <div className="text-center">
                    <div className="leading-16 text-24 text-primary text-left desktop:text-center font-md">Spaventato dai costi? Risparmia<br />più di quanto spendi</div>
                </div>
            </div>
            <div className="col-span-4 desktop:col-span-8 desktop:col-start-3">
                <div className={`text-6 font-rg text-black`} style={{ lineHeight: '21px', marginTop: '29px' }}>
                    Il tuo profilo Tinaba Premium ti da un conto corrente che ti fa risparmiare più di quello che costa! Scopri i vantaggi che puoi ottenere nella tua spesa quotidiana con il nostro simulatore​.
                </div>
            </div>
            <div className="col-span-4 desktop:col-span-4 desktop:col-start-5">
                <div className="text-center">
                    <div className={s.containerButton}>
                        <Button id="btnTrySimulator" className="btn-simulatore-premium" onClick={() => {
                            const wObj = windowObject();
                            if(wObj)
                            {
                                wObj.open("https://premium.tinaba.it/savings-calculator.action");
                            }
                        }}>
                            Prova il simulatore
                        </Button>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default PremiumComeFunziona